
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M5 2.83l2.46 2.46a.996.996 0 101.41-1.41L5.7.7a.996.996 0 00-1.41 0L1.12 3.88a.996.996 0 101.41 1.41L5 2.83zm0 12.34l-2.46-2.46a.996.996 0 10-1.41 1.41L4.3 17.3c.39.39 1.02.39 1.41 0l3.17-3.17a.996.996 0 10-1.41-1.41L5 15.17z"}})]),_c('use',{attrs:{"fill":"#838587","fill-rule":"evenodd","transform":"translate(7 3)","xlink:href":"#a"}})])
          )
        }
      }
    